<template>
  <div>
    <popover-right v-model="isShowRefuse" width="850px" :closed="cancel">
      <h1 class="popover-right-title">{{type === 'new' ? '结佣申请' : '结佣编辑'}}</h1>
      <OrderItem :info="type ==='new' ? baseInfo : info" :orderId="baseInfo.id || info.id" ref="itemRef">
        <p class="title" slot="title">结佣相关</p>
      </OrderItem>
      <div class="pover-right-con reimburse-con">
        <el-form :model="info" class="form-list-info" ref="settleForm" :rules="rules">
          <div class="item item-upload">
            <span class="label label-required">凭证：</span>
            <el-form-item prop="attachments">
              <div class="lebel-con">
                <el-button type="primary" class="upload-btn">上传凭证({{uploadImgList.length}}/10)</el-button>
                <input type="file" title="" class="upload-hidden-btn" id="settleFileUpload" multiple @change="uploadChange" />
                <p class="desc">仅支持上传JPG/JPEG/PNG格式的图片，单张图片大小不超过10M</p>
              </div>
            </el-form-item>
          </div>
          <div class="item upload-img-con" v-if="uploadImgList.length > 0">
            <span class="label"></span>
            <div class="lebel-con clearfix">
              <div v-for="(img, i) in uploadImgList" :key="i" class="img-item">
                <i class="iconfont iconshanchu" @click="remove(i)"></i>
                <img :src="`${img}!watermark?imageView2/3/w/150/h/120/q/100`" @click="toPreview(i)" />
              </div>
            </div>
          </div>
          <div class="item">
            <span class="label">备注：</span>
            <el-form-item prop="remark" class="lebel-con label-con-1">
              <el-input placeholder="请填写备注，不超过150字" type="textarea" :rows="5" :show-word-limit="true" maxlength="150" v-model="info.remark" />
            </el-form-item>
          </div>
          <div class="item">
            <span class="label"></span>
            <div class="lebel-con">
              <div class="custom-btn">
                <el-button type="primary" @click="save">提交</el-button>
                <el-button type="info" @click="hide">取消</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </popover-right>
    <!--  凭证轮播图 -->
    <swipe :dataList="uploadImgList" :previewIndex="previewIndex" v-model="isShowPreview" type="noWater" />
  </div>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import OrderItem from './component/orderItem';
import {imageBeforeUpload} from '@/plugins/cos';
import {applyCommission, getOrderDetail} from '@/api/workflow';
import { settlementApproveEdit, getApproveSettlementDetail, getFailureApprove } from '@/api/approve';
import defaultSetting from '@/setting/index';
import Swipe from '@/components/swipe/index';
export default {
  name: 'ApplySettlement',
  components: {
    PopoverRight,
    OrderItem,
    Swipe
  },
  props: {
    value: String,
    approvalId: [Number, String],
    orderId: [Number, String],
    type: {
      type: String,
      default: 'new'
    },
    emitName: {
      type: String,
      default: ''
    },
    is_failure_stage: Boolean
  },
  computed: {
    isShowRefuse () {
      return this.value === 'settlement';
    }
  },
  data () {
    return {
      info: {
        remark: '',
        attachments: ''
      },
      rules: {
        attachments: [
          {required: true, message: '请选择凭证', trigger: 'change'}
        ]
      },
      uploadImgList: [],
      isShowPreview: false,
      previewIndex: 0,
      baseInfo: {}
    }
  },
  mounted () {
    if (this.type !== 'new') {
      this.initApproveDetail();
    }else{
      if (this.is_failure_stage) {
        this.initFalureData();
      }
      this.initOrderDetail();
    }
  },
  methods: {
    async initFalureData () {
      try {
        const res = await getFailureApprove({
          order_id: this.orderId
        })
        this.info = {
          ...this.info,
          ...res
        }
        if (res.attachment && res.attachment.length > 0) {
          this.info.attachments = 'attachments';
          this.uploadImgList = res.attachment.map(v => {
            const path = v['path'].replace(/\!watermark/g, '');
            return defaultSetting.sourceUrl + path;
          });
        }
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    cancel () {
      this.info = {
        remark: '',
        attachments: ''
      };
      this.uploadImgList = [];
      this.$refs.settleForm && this.$refs.settleForm.clearValidate();
      this.$emit('input', '');
    },
    hide () {
      this.cancel();
    },
    async initOrderDetail () {
      try {
        const res = await getOrderDetail(this.orderId);
        this.baseInfo = res || {};
      } catch (error) {
        this.$message.error(error.msg || '查找订单详情出现错误');
      }
    },
    uploadChange (e) {
      imageBeforeUpload(e.target.files, this.uploadCall, {length : this.uploadImgList.length});
    },
    uploadCall (list = [], msg) {
      document.getElementById("settleFileUpload").value = '';
      if (msg) {
        this.$message.error(msg);
      }
      this.uploadImgList.push(...(list.map(v => `https://${v}`)));
      if (this.uploadImgList.length > 0) {
        this.info = Object.assign({}, this.info, {
          attachments: 'attachments'
        })
        this.$nextTick(() => {
          this.$refs.settleForm.validateField('attachments');
        })
      }
    },
    remove (index) {
      this.uploadImgList.splice(index, 1);
      if (this.uploadImgList.length <= 0) {
        this.info = Object.assign({}, this.info, {
          attachments: ''
        })
        this.$nextTick(() => {
          this.$refs.settleForm.validateField('attachments');
        })
      }
    },
    async initApproveDetail () {
      try {
        const res = await getApproveSettlementDetail(this.approvalId, {
          approvalId: this.approvalId
        });
        this.info = {
          ...res.order,
          ...res.business,
          ...res.voucher,
          customer_name: res.customer.name,
          project_name: res.project.name,
          house_type_name: res.project.house_type_name,
          reason: res.voucher.remark,
          id: res.order.id
        };
        if (res.attachment && res.attachment.length > 0) {
          this.info.attachments = 'attachments';
          this.uploadImgList = res.attachment.map(v => {
            const path = v['path'].replace(/\!watermark/g, '');
            return defaultSetting.sourceUrl + path;
          });
        }
      } catch (error) {
        this.$message.error(error.msg || '获取审批详情出现错误');
      }
    },
    async save () {
      const result = await this.$refs.itemRef.validate();
      this.$refs.settleForm && this.$refs.settleForm.validate(async valid => {
        if (!valid || !result.status) return null;
        try {
         const params = {
            ...result.data,
            refund_amount: this.info.refund_amount,
            order_id: this.info.id,
            remark: this.info.remark
          };
          if (this.uploadImgList.length > 0) {
            params.attachments = this.uploadImgList.map(v => {
              const imgList = v.split('/');
              return imgList.filter((img, i) => {
                if (i >2) return img;
                return false;
              }).join('/');
            }).join('||');
          }
          if (this.type === 'new') {
            params.order_id = this.baseInfo.id;
            await applyCommission(params);
          } else {
            await settlementApproveEdit(this.approvalId, params);
          }
          this.$message.success('结佣操作提交成功!');
          this.hide();
          this.$parent.initList && this.$parent.initList();
        } catch (error) {
          this.$message.error(error.msg || '提交失败，请重试');
        }
      })
    },
    toPreview (key) {
      this.isShowPreview = true;
      this.previewIndex = key;
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/approve.less');
</style>
<style scoped lang="less">
.pt15{
  padding-top: 15px !important;
}
.reimburse-con{
  padding-top: 0 !important;
  .item .label{
    min-width: 100px !important;
  }
}
</style>
